import LookupPictureModifiedAfterRequestModelBase from '../_generated/modelBases/lookup-picture-modified-after-request-model-base';

export default class LookupPictureModifiedAfterRequestModel extends LookupPictureModifiedAfterRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
